import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export let banner_data = [
  {
    id: 1,
    img: "img/home/blackcaps.png",
    link: "https://sportsfan.co.nz/collections/blackcaps"
  },
  {
    id: 2,
    img: "img/home/all blacks.png",
    link: "https://sportsfan.co.nz/collections/all-blacks"
  },
  {
    id: 3,
    img: "img/home/all whites.png",
    link: "https://sportsfan.co.nz/collections/all-whites"
  },
  {
    id: 4,
    img: "img/home/Super Rugby.png",
    link: "https://sportsfan.co.nz/collections/super-rugby"
  },

  

];

function MerchPartnerComponent() {
  return (
    <div className="merch-partner-container">
      <Carousel autoPlay infiniteLoop showThumbs={false} interval={8000}>
        {banner_data.map((item) => (
             <a href={item.link} target="_blank" rel="noopener noreferrer">
          <div className="topbanner" key={item.id}>
           
            <img className="banner" src={item.img} className="merch-image" alt={`Merch ${item.id}`} />
            
          </div>
          </a>
        ))}
      </Carousel>
      




    </div>
  );
}




// function BannerHome() {
//   return (

//       <div className="">
//         <MerchPartnerComponent />
        
//       </div>


//   );
// }




function BannerHome() {
  return (
    <div className="">

      <MerchPartnerComponent />

{/* <div className="secondary-banner" style={{ marginTop: '20px', marginBottom: '20px' }}>
  <a href="https://sportsfan.co.nz/" target="_blank" rel="noopener noreferrer">
    <video
      src="img/banner.mp4"
      poster="img/topBanner.png"
      style={{ width: '100%' }}
      autoPlay
      loop
      muted
      playsInline
    ></video>
  </a>
</div>






      <div className="secondary-banner" style={{ marginTop: '20px', marginBottom: '20px' }}>
        <a href="https://shop.nzfootball.co.nz" target="_blank" rel="noopener noreferrer">
          <img src="img/home/nzfbanner.jpg" alt="NZ Football Shop" style={{ width: '100%' }} />
        </a>
      </div> */}
          </div>
  );
}


export default BannerHome;
